import { EventCategory, VelavuEventOptions } from "velavu-js-api";

export default interface NormalizedRuleEventOptions {
	message: string;
	phoneNumbers: string[];
	emailAddresses: string[];
	storeEvent: boolean;
	storeAlert: boolean;
}

export function velavuEventOptionsToNormalizedRuleEventOptions(
	rule: VelavuEventOptions | undefined,
): NormalizedRuleEventOptions | null {
	if (rule === undefined) {
		return null;
	}

	return {
		message: rule.message,
		phoneNumbers: rule.sms_numbers ?? [],
		emailAddresses: rule.email_addresses ?? [],
		storeEvent: rule.store_event ?? false,
		storeAlert: rule.store_alert ?? false,
	};
}

export function normalizedRuleEventOptionsToVelavuEventOptions(
	state: NormalizedRuleEventOptions | null,
): VelavuEventOptions | undefined {
	if (state === null) {
		return undefined;
	}

	return {
		category: EventCategory.CustomEvent,
		message: state.message,
		sms_numbers: state.phoneNumbers,
		email_addresses: state.emailAddresses,
		store_event: state.storeEvent,
		store_alert: state.storeAlert,
	};
}
